// Copyright (c) 2018 Comsearch, Inc., All rights reserved

import React from 'react'
import { bool, func, string } from 'prop-types'

const HighlightAll = props => {
  const {
    allRowsHighlighted,
    allRowsHightlightToggle,
    hasResults,
    highlightRows,
    idRoot,
  } = props

  const labelClasses = `display-flex align-items-center ${hasResults ? 'pointer' : 'cursor-not-allowed opacity-half'}`

  return (
    highlightRows
      ? (
        <label className={labelClasses}>
          <span
            className={'padding-right-half'}
            id={`${idRoot}-label`}>
            {'Select All'}
          </span>
          <input
            checked={allRowsHighlighted}
            className={'pointer'}
            disabled={!hasResults}
            id={idRoot}
            name={'all-rows-highlighted'}
            onClick={allRowsHightlightToggle}
            type={'checkbox'}
            value={'highlight-all'} />
        </label>
      ) : null
  )
}

HighlightAll.propTypes = {
  allRowsHighlighted: bool.isRequired,
  allRowsHightlightToggle: func.isRequired,
  hasResults: bool.isRequired,
  highlightRows: bool,
  idRoot: string.isRequired,
}

export default HighlightAll
